import { useState, useRef } from 'react';
import { feedbackApi } from '../../api/feedback.api';
import { useUI } from '../../store/UIContext';
import { PageHeader, Btn } from '../../components/ui/index';
import { EmojiBar } from '../../components/ui/EmojiPicker';
import FeedbackMoodPicker, {
  FeedbackHeroLogo,
  FeedbackSuccessLogo,
} from '../../components/feedback/FeedbackMoodPicker';

export default function FeedbackPage() {
  const { addToast } = useUI();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const commentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!rating) { addToast('لطفاً امتیاز بدهید', 'error'); return; }
    setLoading(true);
    try {
      await feedbackApi.sendFeedback({ rating, comment });
      setSent(true);
      addToast('بازخورد ارسال شد', 'success');
    } catch { addToast('خطا در ارسال بازخورد', 'error'); }
    setLoading(false);
  };

  return (
    <div className="fade-in">
      <PageHeader title="ارسال بازخورد" subtitle="نظر شما کیفیت پشتیبانی را بهتر می‌کند" />
      <div className="pj-feedback-card">
        {sent ? (
          <div className="pj-feedback-success">
            <FeedbackSuccessLogo />
            <h3>ممنون از بازخورد شما</h3>
            <p>نظر شما ثبت شد و برای بهبود خدمات استفاده می‌شود.</p>
          </div>
        ) : (
          <>
            <div className="pj-feedback-hero">
              <FeedbackHeroLogo />
              <div>
                <h3>تجربه شما چطور بود؟</h3>
                <p>یکی از لوگوها را انتخاب کنید؛ بعد اگر خواستید توضیح بدهید.</p>
              </div>
            </div>
            <FeedbackMoodPicker value={rating} onChange={setRating} />
            <label className="pj-feedback-label" htmlFor="feedback-comment">توضیح (اختیاری)</label>
            <textarea
              id="feedback-comment"
              ref={commentRef}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="چی خوب بود، چی می‌تواند بهتر شود؟"
              rows={4}
              className="pj-feedback-comment"
            />
            <div style={{ marginBottom: 16 }}>
              <EmojiBar inputRef={commentRef} value={comment} onInsert={setComment} />
            </div>
            <Btn onClick={submit} loading={loading} style={{ width: '100%', justifyContent: 'center', minHeight: 44 }}>
              ارسال بازخورد
            </Btn>
          </>
        )}
      </div>
    </div>
  );
}
